import { ReactElement } from "react";

import { PolicyVariants, policyVariantsTitleMap } from "../../constants";
import { Policy } from "../../constants/aquafina";

import PolicyDialog from "./policy-dialog";
import PolicyFullscreen from "./policy-fullscreen";

type PolicyDetailsProps = {
  isOpen?: boolean;
  onClose?: () => void;
  data: Policy;
  variant: PolicyVariants;
  carrierName: string;
  showFullScreen?: boolean;
  subTitleText?: ReactElement<unknown>;
  onRefreshClick?: () => void;
};

export const PolicyDetails = ({
  isOpen = false,
  onClose,
  data,
  variant,
  carrierName,
  subTitleText = undefined,
  showFullScreen = false,
}: PolicyDetailsProps) => {
  const coverageName = policyVariantsTitleMap[variant];

  return showFullScreen ? (
    <PolicyFullscreen
      policyDetailsInfo={data}
      variant={variant}
      subTitleText={subTitleText}
      groupName={data?.groupInformation?.groupName}
      carrierName={carrierName}
      coverageName={coverageName}
    />
  ) : (
    <PolicyDialog
      isOpen={isOpen}
      onClose={onClose as VoidFunction}
      policyDetailsInfo={data}
      variant={variant}
      subTitleText={subTitleText}
      groupName={data?.groupInformation?.groupName}
      carrierName={carrierName}
      coverageName={coverageName}
    />
  );
};

export default PolicyDetails;
